import styles from "./DescriptionParametersSection.module.scss";

// Explicit slots also work when the embedded host suffixes Material UI classes.
export default {
  root: styles.parameterInput,
  notchedOutline: styles.parameterInputOutline,
  focused: styles.parameterInputFocused,
  error: styles.parameterInputError
};
